import { ParsedField, ParsedHouseConsignment, ParsedItem } from 'store/declaration-form-errors/ParsedForm';
import { ICS2_LEVEL_INDEX, Ics2ErrorLevel, Ics2ErrorLocation } from './types';

/**
 * The same location, built from a pre-submission error instead of a customs one. The parsers
 * already number levels 1-based and record each field's path relative to the sub-tree they
 * parsed, so the two sources meet here without either having to know about the other.
 */
export const ics2LocationFromParsedForm = (
    level: Ics2ErrorLevel,
    field?: ParsedField,
    indices: { houseConsignment?: ParsedHouseConsignment; item?: ParsedItem } = {}
): Ics2ErrorLocation => ({
    level,
    houseConsignmentIndex: indices.houseConsignment?.index,
    itemIndex: indices.item?.index ?? ICS2_LEVEL_INDEX,
    fieldPath: field?.path,
});
